const actions = {
    GET_REPUSH_ACTIVATION: 'GET_REPUSH_ACTIVATION',
    GET_REPUSH_ACTIVATION_SUCCESS: 'GET_REPUSH_ACTIVATION_SUCCESS',
    GET_REPUSH_ACTIVATION_FAILED: 'GET_REPUSH_ACTIVATION_FAILED',

    UPDATE_REPUSH_ACTIVATION: 'UPDATE_REPUSH_ACTIVATION',
    UPDATE_REPUSH_ACTIVATION_SUCCESS: 'UPDATE_REPUSH_ACTIVATION_SUCCESS',
    UPDATE_REPUSH_ACTIVATION_FAILED: 'UPDATE_REPUSH_ACTIVATION_FAILED',

    GET_PREPAIDIQ_ACTIVATION_FOR_REPUSH: 'GET_PREPAIDIQ_ACTIVATION_FOR_REPUSH',
    GET_PREPAIDIQ_ACTIVATION_FOR_REPUSH_SUCCESS: 'GET_PREPAIDIQ_ACTIVATION_FOR_REPUSH_SUCCESS',
    GET_PREPAIDIQ_ACTIVATION_FOR_REPUSH_FAILED: 'GET_PREPAIDIQ_ACTIVATION_FOR_REPUSH_FAILED',

    UPDATE_PREPAIDIQ_ACTIVATION_FOR_REPUSH: 'UPDATE_PREPAIDIQ_ACTIVATION_FOR_REPUSH',
    UPDATE_PREPAIDIQ_ACTIVATION_FOR_REPUSH_SUCCESS: 'UPDATE_PREPAIDIQ_ACTIVATION_FOR_REPUSH_SUCCESS',
    UPDATE_PREPAIDIQ_ACTIVATION_FOR_REPUSH_FAILED: 'UPDATE_PREPAIDIQ_ACTIVATION_FOR_REPUSH_FAILED',

    GET_PORTIN_ACTIVATION_FOR_REPUSH: 'GET_PORTIN_ACTIVATION_FOR_REPUSH',
    GET_PORTIN_ACTIVATION_FOR_REPUSH_SUCCESS: 'GET_PORTIN_ACTIVATION_FOR_REPUSH_SUCCESS',
    GET_PORTIN_ACTIVATION_FOR_REPUSH_FAILED: 'GET_PORTIN_ACTIVATION_FOR_REPUSH_FAILED',

    UPDATE_PORTIN_ACTIVATION_FOR_REPUSH: 'UPDATE_PORTIN_ACTIVATION_FOR_REPUSH',
    UPDATE_PORTIN_ACTIVATION_FOR_REPUSH_SUCCESS: 'UPDATE_PORTIN_ACTIVATION_FOR_REPUSH_SUCCESS',
    UPDATE_PORTIN_ACTIVATION_FOR_REPUSH_FAILED: 'UPDATE_PORTIN_ACTIVATION_FOR_REPUSH_FAILED',

    RESET_MESSAGE: "RESET_MESSAGE",

    getRepushActivation: (data) => ({
        type: actions.GET_REPUSH_ACTIVATION,
        payload: { data }
    }),
    getRepushActivationSuccess: (result) => ({
        type: actions.GET_REPUSH_ACTIVATION_SUCCESS,
        result
    }),
    getRepushActivationFailed: (error) => ({
        type: actions.GET_REPUSH_ACTIVATION_FAILED,
        error
    }),

    updateRepushActivation: (data, searchData) => ({
        type: actions.UPDATE_REPUSH_ACTIVATION,
        payload: { data, searchData }
    }),
    updateRepushActivationSuccess: (message) => ({
        type: actions.UPDATE_REPUSH_ACTIVATION_SUCCESS,
        message
    }),
    updateRepushActivationFailed: (error) => ({
        type: actions.UPDATE_REPUSH_ACTIVATION_FAILED,
        error
    }),

    getPrepaidIQActivationforRepush: (data) => ({
        type: actions.GET_PREPAIDIQ_ACTIVATION_FOR_REPUSH,
        payload: { data }
    }),
    getPrepaidIQActivationforRepushSuccess: (result) => ({
        type: actions.GET_PREPAIDIQ_ACTIVATION_FOR_REPUSH_SUCCESS,
        result
    }),
    getPrepaidIQActivationforRepushFailed: (error) => ({
        type: actions.GET_PREPAIDIQ_ACTIVATION_FOR_REPUSH_FAILED,
        error
    }),

    updatePrePaidIQActivationForRepush: (data, searchData) => ({
        type: actions.UPDATE_PREPAIDIQ_ACTIVATION_FOR_REPUSH,
        payload: { data, searchData }
    }),
    updatePrePaidIQActivationForRepushSuccess: (message) => ({
        type: actions.UPDATE_PREPAIDIQ_ACTIVATION_FOR_REPUSH_SUCCESS,
        message
    }),
    updatePrePaidIQActivationForRepushFailed: (error) => ({
        type: actions.UPDATE_PREPAIDIQ_ACTIVATION_FOR_REPUSH_FAILED,
        error
    }),

    getPortinActivationforRepush: (data) => ({
        type: actions.GET_PORTIN_ACTIVATION_FOR_REPUSH,
        payload: { data }
    }),
    getPortinActivationforRepushSuccess: (result) => ({
        type: actions.GET_PORTIN_ACTIVATION_FOR_REPUSH_SUCCESS,
        result
    }),
    getPortinActivationforRepushFailed: (error) => ({
        type: actions.GET_PORTIN_ACTIVATION_FOR_REPUSH_FAILED,
        error
    }),

    updatePortinActivationForRepush: (data, searchData) => ({
        type: actions.UPDATE_PORTIN_ACTIVATION_FOR_REPUSH,
        payload: { data, searchData }
    }),
    updatePortinActivationForRepushSuccess: (message) => ({
        type: actions.UPDATE_PORTIN_ACTIVATION_FOR_REPUSH_SUCCESS,
        message
    }),
    updatePortinActivationForRepushFailed: (error) => ({
        type: actions.UPDATE_PORTIN_ACTIVATION_FOR_REPUSH_FAILED,
        error
    }),

    resetMessage: () => ({
        type: actions.RESET_MESSAGE,
    })
};
export default actions;
